import { render, staticRenderFns } from "./ApplyPromoCodesCheckout.vue?vue&type=template&id=20e8434a&"
import script from "./ApplyPromoCodesCheckout.vue?vue&type=script&lang=ts&"
export * from "./ApplyPromoCodesCheckout.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyPromoCodesCheckout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports